import React from 'react';
import { Paper } from '@mui/material';

export const OpalCard = ({ children }) => {
    return (
        <Paper
            className="opal-card"
            elevation={0}
            sx={{
                padding: '2px',
                border: '2px solid transparent',
                borderRadius: '12px',
                transition: 'border 250ms cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                background: '#fff',
                overflow: 'hidden',
                '&:hover': {
                    border: '2px solid #dde1fb',
                    borderRadius: '12px',
                },
            }}
        >
            {children}
        </Paper>
    );
};

export const paperStyles = {
    padding: 2,
    borderRadius: '10px',
    '&:hover': {
        borderRadius: '10px',
    },
};
